import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import getObjectValue from "libs/getObjectValue";
import {Collapse} from "@material-ui/core";
import GridBlock from "../../../../GridBlock";
import NoticeTypography from "../../components/inputs/NoticeTypography";


function TenderCompletionDivided(
    {
        id,
        formikProps,
        index
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
        </GridBlock>

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("tenderCompletionType")}
            items={getDict("ENUM.003")}
            required
        />

        <Collapse in={gVal("tenderCompletionType") === "uniewaznienie"}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("legalBasisForWithdrawal")}
                items={getDict("SL.MO.020")}
                required
            />
        </Collapse>

        <Collapse in={gVal("tenderCompletionType") === "uniewaznienie"}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("justificationForWithdrawal")}
                multiple
            />
        </Collapse>
    </>)
}

TenderCompletionDivided.propTypes = {};

export default TenderCompletionDivided;
